import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormTextField } from './KioskFormTextField/KioskFormTextField';
import { WebFormTextField } from './WebFormTextField/WebFormTextField';
import { FormTextFieldProps } from './FormTextField.types';

const FormTextField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required = false,
    autoFocus,
    keyboardLayout = KeyboardLayouts.Alphanumeric,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
    onBlurCallback,
}: FormTextFieldProps) => {

    return (
        isElectron() ? (
            <KioskFormTextField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                keyboardLayout={keyboardLayout}
                shiftAfterSpace={shiftAfterSpace}
                shiftAfterPeriod={shiftAfterPeriod}
                shiftAfterAmpersand={shiftAfterAmpersand}
                hideKeyboardOnClickOut={hideKeyboardOnClickOut}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
                onBlurCallback={onBlurCallback}
            />
        ) : (
            <WebFormTextField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
                onBlurCallback={onBlurCallback}
            />
        )
    );
});

export default FormTextField;
